/**
 * Composant pour l'affichage de l'evolution d'un rapport.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportService } from '../../report.service';
import { SessionService } from '../../../../../../shared/src/lib/service/session.service';
import { FormationService } from '../../../../../../shared/src/lib/service/formation.service';
import { Location } from '@angular/common';
import { TeacherService } from '../../../../../../shared/src/lib/service/teacher.service';
import { AuthenticationService } from '../../../../../../shared/src/lib/service/authentification.service';
import { OccurrenceService } from '../../../../../../shared/src/lib/service/occurrence.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-absent',
  templateUrl: './absent.component.html',
  styleUrls: ['./absent.component.scss']
})
export class AbsentComponent implements OnInit, OnDestroy {
  previousReport: any;
  formation: any;
  occurrence: any;
  occurrence_id: any;
  occurrenceTeacher: any;
  myUser: any;
  callServiceFormation;
  myReportTeacher: any;
  defaultAvatar = environment.static + '/avatar.png';


  constructor(
    private route: ActivatedRoute,
    private _location: Location,
    private teacherService: TeacherService,
    private authenticationService: AuthenticationService,
    private occurrenceService: OccurrenceService,
    private formationService: FormationService,
  ) { }

  ngOnInit() {
    this.occurrence_id = this.route.snapshot.params.id;
    this.authenticationService.currentUserSubject.subscribe(
      user => {
        if (user && user.hasOwnProperty('user')) {
          this.myUser = user;
          this.occurrenceService.getObservableOccurenceById(this.occurrence_id)
            .subscribe(_occurrence => {
              this.occurrence = _occurrence;

              this.formationService.getObservableFormationByUrl(this.occurrence.session.formation)
                .subscribe(
                  _formation => {
                    this.formation = _formation;
                  }
                );
            });
        }
      }
    )
  }

  previousStep() {
    this._location.back();
  }

  ngOnDestroy() {
    if (this.callServiceFormation) {
      this.callServiceFormation.unsubscribe()
    }
  }

}
